export enum SchemaChangeType
{
    add="add",
    change="change",
    rename="rename"
}